import { render, staticRenderFns } from "./FiveModalCounter.vue?vue&type=template&id=22cc0dc3&scoped=true"
import script from "./FiveModalCounter.vue?vue&type=script&lang=js"
export * from "./FiveModalCounter.vue?vue&type=script&lang=js"
import style0 from "./FiveModalCounter.vue?vue&type=style&index=0&id=22cc0dc3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc0dc3",
  null
  
)

export default component.exports